import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import {
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  Chip,
  Box,
  Pagination,
  Select,
  MenuItem,
} from "@mui/material";
import { Visibility } from "@mui/icons-material";
import CreateCustomerModal from "../component/editcustomermodel/CreateCustomerModal";
import { cellSX, layoutCSS } from "../component/common/commonStyle";
import { useFetchCustomersQuery } from "../store/services/customerApi";

const ManageCustomer = () => {
  const navigate = useNavigate();

  const [isCreateCustomerModalOpen, setCreateCustomerModalOpen] =
    useState(false);

  // ✅ FIX: declare first
  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  // ✅ API call
  const { data, isLoading, refetch } = useFetchCustomersQuery(
    {
      page,
      limit: rowsPerPage,
    },
    {
      refetchOnMountOrArgChange: true, // avoid 304 cache issue
    }
  );

  const [customers, setCustomers] = useState([]);

  useEffect(() => {
    if (data?.data) {
      setCustomers(data.data);
    }
  }, [data]);

  const totalPages = data?.pagination?.totalPages || 1;

  const handleCreateCustomerClick = () => {
    setCreateCustomerModalOpen(true);
  };

  const handleCloseCreateCustomerModal = () => {
    setCreateCustomerModalOpen(false);
  };

  const handleCustomerCreated = async () => {
    await refetch();
  };

  if (isLoading) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
          flexDirection: "column",
        }}
      >
        <img src="/ZZ5H.gif" alt="Loading..." width="150" />
        <Typography variant="h6" style={{ marginTop: 20 }}>
          Please wait...
        </Typography>
      </div>
    );
  }

  return (
    <Box sx={layoutCSS}>
      <Box sx={{ display: "flex", justifyContent: "space-between", mb: 2 }}>
        <Typography variant="h6" sx={{ fontSize: "0.9rem", fontWeight: "bold" }}>
          Manage Customer
        </Typography>
        <Button
          variant="contained"
          color="primary"
          onClick={handleCreateCustomerClick}
          sx={{ width: "150px", marginBottom: "20px", fontSize: "0.7rem" }}
        >
          Create Customer
        </Button>
      </Box>

      {isCreateCustomerModalOpen && (
        <CreateCustomerModal
          handleClose={handleCloseCreateCustomerModal}
          onCustomerCreated={handleCustomerCreated}
        />
      )}

      {/* Table */}
      <TableContainer component={Paper}>
        <Table sx={{ minWidth: 650 }}>
          <TableHead
            sx={{
              bgcolor: "#0288d1",
              "& th": {
                color: "white",
                fontSize: "0.8rem",
                border: "0.5px solid #B0B0B0",
                textAlign: "center",
                paddingY: "4px",
                paddingX: "6px",
              },
            }}
          >
            <TableRow>
              <TableCell>Customer ID</TableCell>
              <TableCell>Username</TableCell>
              <TableCell>Customer Name</TableCell>
              <TableCell>Mobile</TableCell>
              <TableCell>Email</TableCell>
              <TableCell>Balance</TableCell>
              <TableCell>Status</TableCell>
              <TableCell>Action</TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {customers.length > 0 ? (
              customers.map((customer) => (
                <TableRow
                  key={customer.customer_id}
                  sx={{
                    "& td": {
                      border: "0.5px solid #B0B0B0",
                      paddingY: "1px",
                      textAlign: "center",
                    },
                  }}
                >
                  <TableCell sx={cellSX}>
                    {customer.customer_id || "N/A"}
                  </TableCell>
                  <TableCell sx={cellSX}>
                    {customer.username || "N/A"}
                  </TableCell>
                  <TableCell sx={cellSX}>
                    {customer.customer_profile?.customer_name || "N/A"}
                  </TableCell>
                  <TableCell sx={cellSX}>
                    {customer.customer_profile?.customer_mobile || "N/A"}
                  </TableCell>
                  <TableCell sx={cellSX}>
                    {customer.customer_profile?.customer_email || "N/A"}
                  </TableCell>
                  <TableCell sx={cellSX}>
                    {customer.customer_profile?.parameter?.balance ?? "0"}
                  </TableCell>

                  <TableCell sx={cellSX}>
                    {customer.is_active ? (
                      <Chip label="Active" color="success" />
                    ) : (
                      <Chip label="Inactive" color="error" />
                    )}
                  </TableCell>

                  <TableCell sx={cellSX}>
                    <Button
                      variant="outlined"
                      onClick={() =>
                        navigate(`/profile/${customer.customer_id}`)
                      }
                      sx={{ borderRadius: 10 }}
                    >
                      <Visibility />
                    </Button>
                  </TableCell>
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell colSpan={8} align="center">
                  No customer details found.
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>

      {/* Pagination + Rows Per Page */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mt: 2,
        }}
      >
        {/* Rows per page */}
        <Select
          value={rowsPerPage}
          onChange={(e) => {
            setRowsPerPage(e.target.value);
            setPage(1);
          }}
          size="small"
        >
          {[10, 25, 50].map((val) => (
            <MenuItem key={val} value={val}>
              {val}
            </MenuItem>
          ))}
        </Select>

        {/* Pagination */}
        <Pagination
          count={totalPages}
          page={page}
          onChange={(e, value) => setPage(value)}
          color="primary"
          size="small"
        />
      </Box>
    </Box>
  );
};

export default ManageCustomer;